require('./reimburseInvestmentSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// const Router = require('react-router');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const ReimburseInvestmentDetails = require('components/hireInvestmentFunds/reimburseInvestmentDetails/reimburseInvestmentDetails');

const ReimburseInvestmentSuccess = props => {
    const { immReimburseInvestment, immFlagBasedFeatures } = props;
    const mainButton = {
        label: formatText('brokerReimburseInvestmentSuccess-finish'),
        url:'/myprofile/broker',
        modifier: 'secondary'
    }
    
    return (
        <WizardSuccess
            successMessage={formatText('brokerReimburseInvestmentSuccess-successMessage')}
            mainButton={mainButton}
        >
            <div className="reimburse-investment-success__details">
                <FormattedText value="brokerReimburseInvestmentSuccess-details" />
            </div>
            <ReimburseInvestmentDetails 
                immReimburseInvestment={immReimburseInvestment}
                immFlagBasedFeatures={immFlagBasedFeatures}
            />
        </WizardSuccess>
    );
};

ReimburseInvestmentSuccess.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
};
module.exports = ReimburseInvestmentSuccess;